import React from "react";

export default function PowerSelector({ vehicleCategory, selectedPower, onSelect, disabled }) {
    const powerOptions = {
        auto: [
            { value: "3cv", label: "3 CV et moins" },
            { value: "4cv", label: "4 CV" },
            { value: "5cv", label: "5 CV" },
            { value: "6cv", label: "6 CV" },
            { value: "7cv", label: "7 CV et plus" },
        ],
        moto: [
            { value: "1-2cv", label: "1 ou 2 CV" },
            { value: "3-5cv", label: "3, 4 ou 5 CV" },
            { value: "5cv+", label: "Plus de 5 CV" },
        ],
        cyclo: [
            { value: "cyclo", label: "50 cm³ et moins" },
        ],
    };

    const options = vehicleCategory ? powerOptions[vehicleCategory] : [];

    return (
        <div className="flex flex-wrap justify-center gap-2">
            {options.map((option) => {
                const isSelected = selectedPower === option.value;
                const selectedClasses = isSelected
                    ? "bg-slate-800 hover:bg-slate-700 text-white shadow-md"
                    : "bg-stone-100 hover:bg-stone-50 text-gray-900";

                return (
                    <button
                        key={option.value}
                        onClick={() => onSelect(option.value)}
                        disabled={disabled}
                        className={`cursor-pointer ${selectedClasses} active:bg-slate-600 active:text-white focus:ring focus:ring-slate-300 rounded-lg px-3 sm:px-4 py-2 sm:py-3 text-xs sm:text-sm font-semibold disabled:cursor-not-allowed`}
                        aria-label={`${isSelected ? "Sélectionné: " : ""}${option.label}`}
                        aria-pressed={isSelected}
                    >
                        {option.label}
                    </button>
                );
            })}
        </div>
    );
}